import { Link } from 'react-router-dom'
import './Privacy.scss'

const Privacy = () => {
    return (
        <main className='faq privacy'>

            <header className='faq__header privacy__header'>
                <div className='faq__header-wrapper'> </div>
            </header>

            <section className='faq__main'>
                <h2 className='faq__main-title' id='deposit-info'>PRIVACY POLICY</h2>
                <ul className='faq__main-list'>
                    <h5 className='faq__main-subtitle'>Last Updated: May 5, 2024</h5>
                    <li className='faq__main-item'>
                        <p className='faq__main-answer'> This privacy notice for VisuaLinLin (doing business as TraveLinLin) ("us", "we", or "our") operates the VisuaLinLin website (the "Service").</p>
                        <p className='faq__main-answer'>This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.</p>
                        <p className='faq__main-answer'>We will not use or share your information with anyone except as described in this Privacy Policy.</p>
                    </li>
                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>INFORMATION COLLECTION AND USE</h6>
                        <p className='faq__main-answer'>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information ("Personal Information") may include, but is not limited to:</p>
                        <ul className='faq__main-answer'>
                            <li className='faq__main-answer-item'>Name</li>
                            <li className='faq__main-answer-item'>Email Address</li>
                            <li className='faq__main-answer-item'>Telephone Number </li>
                            <li className='faq__main-answer-item'>Contact Preferences</li>
                        </ul>

                    </li>

                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>LOG DATA</h6>
                        <p className='faq__main-answer'>We collect information that your browser sends whenever you visit our Service ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages and other statistics.</p>
                    </li>

                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>COOKIES</h6>
                        <p className='faq__main-answer'>Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>
                        <p className='faq__main-answer'>We use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
                    </li>


                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>SERVICE PROVIDERS</h6>
                        <p className='faq__main-answer'>We may employ third party companies and individuals to facilitate our Service, to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.</p>
                        <p className='faq__main-answer'>These third parties have access to your Personal Information only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                    </li>

                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>LINKS TO OTHER SITES</h6>
                        <p className='faq__main-answer'>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
                    </li>


                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>SECURITY</h6>
                        <p className='faq__main-answer'>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
                        <p className='faq__main-answer'>We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>
                    </li>


                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>CHILDREN'S POLICY</h6>
                        <p className='faq__main-answer'>Our Service does not address anyone under the age of 18 ("Children").</p>
                        <p className='faq__main-answer'>We do not knowingly collect personally identifiable information from children under 18. If you are a parent or guardian and you are aware that your child has provided us with Personal Information, please contact us. If we discover that a child under 18 has provided us with Personal Information, we will delete such information from our servers immediately.
                        </p>
                    </li>


                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>COMPLIANCE WITH LAWS</h6>
                        <p className='faq__main-answer'>We will disclose your Personal Information where required to do so by law or subpoena.</p>
                    </li>

                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>CHANGES TO THIS PRIVACY POLICY</h6>
                        <p className='faq__main-answer'>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                        <p className='faq__main-answer'>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                    </li>


                    <li className='faq__main-item'>
                        <h6 className='faq__main-question'>CONTACT US</h6>
                        <p className='faq__main-answer'>If you have any questions about this Privacy Policy, please
                            <Link to="/contact" className='privacy__link' > contact us.</Link></p>
                    </li>



                </ul>
            </section>
        </main>

    )
}

export default Privacy